export const GET_SELLER_WALLET_PLANS_REQUEST = "GET_SELLER_WALLET_PLANS_REQUEST";
export const GET_SELLER_WALLET_PLANS_SUCCESS = "GET_SELLER_WALLET_PLANS_SUCCESS";
export const GET_SELLER_WALLET_PLANS_FAILURE = "GET_SELLER_WALLET_PLANS_FAILURE";
export const GET_SELLER_WALLET_PLANS_RESET = "GET_SELLER_WALLET_PLANS_RESET";
export const getSellerWalletPlansRequest = (payload) => ({
    type: GET_SELLER_WALLET_PLANS_REQUEST,
    payload,
});
export const getSellerWalletPlansSuccess = (payload) => ({
    type: GET_SELLER_WALLET_PLANS_SUCCESS,
    payload,
});
export const getSellerWalletPlansFailure = (payload) => ({
    type: GET_SELLER_WALLET_PLANS_FAILURE,
    payload,
});
export const getSellerWalletPlansReset = () => ({
    type: GET_SELLER_WALLET_PLANS_RESET,
});
